<button
  #tooltip
  [id]="id"
  type="button"
  class="tooltip"
  role="tooltip"
  aria-label="Bulle d'information"
  (mouseenter)="showTooltip()"
  (mouseleave)="hideTooltip()"
  (focus)="showTooltip()"
  (focusout)="hideTooltip()"
  (pressEscapeKey)="hideTooltip()"
  (click)="click()"
  appPressEscapeKey
>
  <span class="tooltip__text" aria-describedby="tooltip-content">i</span>
  <div
    #tooltipContent
    [@fadeInOnEnter]
    [@fadeOutOnLeave]
    [style.left]="left"
    [style.top]="top"
    class="tooltip__container"
    [class.tooltip__container--into-modal]="isLargeContentIntoModal"
    [class.tooltip__container--hidden]="(showTooltip$ | async) === false"
    (mouseenter)="showTooltip()"
    (mouseleave)="hideTooltip()"
    id="tooltip-content"
  >
    <ng-content></ng-content>
  </div>
</button>
